import { Target, Microscope, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { QUIENES_SOMOS } from "@/data/content";

const ICONS = { Target, Microscope, ShieldCheck };

export const QuienesSomos = () => {
  return (
    <section
      id="quienes-somos"
      data-testid="quienes-somos-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal className="max-w-3xl">
          <p className="text-sm font-medium text-[#E60000] tracking-[0.2em] uppercase mb-6">
            {QUIENES_SOMOS.eyebrow}
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] leading-tight">
            {QUIENES_SOMOS.title}
          </h2>
          <p className="text-lg font-light text-[#525252] leading-relaxed mt-8">
            {QUIENES_SOMOS.description}
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E5E5E5] border border-[#E5E5E5] mt-20">
          {QUIENES_SOMOS.pillars.map((pillar, i) => {
            const Icon = ICONS[pillar.icon];
            return (
              <Reveal
                key={pillar.title}
                delay={i * 0.12}
                className="bg-white p-8 md:p-10 group relative overflow-hidden hover:bg-[#0A0A0A] transition-colors duration-500"
                testId={`pillar-${i}`}
              >
                <span className="absolute top-6 right-8 text-5xl font-black text-[#F5F5F5] group-hover:text-white/10 transition-colors duration-500 select-none">
                  0{i + 1}
                </span>
                <Icon
                  className="w-9 h-9 text-[#E60000] mb-6 relative group-hover:scale-110 transition-transform duration-500"
                  strokeWidth={1.5}
                />
                <h3 className="text-xl font-bold text-[#0A0A0A] group-hover:text-white mb-4 relative transition-colors duration-500">
                  {pillar.title}
                </h3>
                <p className="text-[#525252] group-hover:text-[#A3A3A3] leading-relaxed relative transition-colors duration-500">
                  {pillar.description}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default QuienesSomos;
